// eslint-disable-next-line import/prefer-default-export
export const GET_SERVICE_REPORT = 'GET_SERVICE_REPORT';
export const RESET_SERVICE_REPORT = 'RESET_SERVICE_REPORT';
